<dxp-flex-layout>
    <dxp-flex-layout-item slot="column-1" column-width-lg="12" padding-style-sm="16px 16px" class="search-panel-title">
        ALL REQUESTS
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout>
    <dxp-flex-layout-item slot="column-1" column-width-md="9" padding-style-sm="10px 15px">
        <div class="child">
            <dxp-search data-theme="dxp-theme-b2b" search-type="simple" search-box-size="sm" placeholder="Search" class="for-pipe-separator-child"
                (valueCleared)="searchTermCleared($event)" show-suggestions="false"
                (searchInputText)="searchTermChanged($event)" #searchBoxReference>
            </dxp-search>
        </div>
    </dxp-flex-layout-item>
    <dxp-flex-layout-item slot="column-2" column-width-md="1" padding-style-sm="20px 0px"><span class="pipe">|</span>
    </dxp-flex-layout-item>
    <dxp-flex-layout-item slot="column-3" column-width-md="2" padding-style-sm="20px 0px">
        <maker-checker-filter-form (filterQuery)="this.updateFilter($event)"></maker-checker-filter-form>
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout class="border-bottom">
    <dxp-flex-layout-item slot="column-1" column-width-lg="12" padding-style-sm="10px 15px">
        <dxp-multi-selector selector-id="tags" data-source-key-name="description" [items]="this.tags" max-limit="1"
            search-placeholder="{{msg.PlaceHolders.SelectOptions}}" placeholder="{{msg.PlaceHolders.SelectOptions}}"
            label="Filter request by tag" optional=true (selectedOptions)="setSelectedTag($event)" multi-search="true"
            max-limit="1" list-aria-label="Filter request by tag"  [value]="this.optionalSelectedTag?.description" #tagsReference>
        </dxp-multi-selector>
    </dxp-flex-layout-item>
    <dxp-flex-layout-item slot="column-2" column-width-lg="12" padding-style-sm="10px 15px">
        <span class="status-label filter-pills"><strong>Filters:</strong></span>
        <dxp-pills class="filter-pills" removable="false" [text]="this.filterData.status.name"
            *ngIf="this.filterData.status.id"></dxp-pills>
        <dxp-pills class="filter-pills" removable="false" [text]="this.filterData.requester.name"
            *ngIf="this.filterData.requester.name"></dxp-pills>
        <dxp-pills class="filter-pills" removable="false" text="{{this.filterData.fromDate | date: 'dd MMM yyyy'}} - {{this.filterData.toDate | date: 'dd MMM yyyy'}}"
            *ngIf="this.filterData.fromDate"></dxp-pills>
        <dxp-pills class="filter-pills" removable="false" [text]="this.filterData.actionTakenBy.name"
            *ngIf="this.filterData.actionTakenBy.name"></dxp-pills>
        <dxp-link class="filter-pills" type="dxp-btn-custom-link" text="Clear all"
            (click)="this.resetFilters()"></dxp-link>
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout>
    <dxp-flex-layout-item slot="column-1" column-width-lg="12" padding-style-sm="10px 0px 0px 15px">
        <dxp-radio-group input-id="request-type" alignment="horizontal" name="requestTypeOptions" required="false"
            label="Request types" validation-message="Please select request type."
            (radioSelected)="setSelectedRequestType($event)">
            <dxp-radio-button name="requestTypeOptions" #radioOptions *ngFor="let requestType of this.requestTypes;let indexOfElement = index;"
                [label]="requestType.name" [radioKey]="requestType.id" [value]="requestType.id"
                aria-label="{{'Filter by ' + requestType.name + 'request type'}}"
                [checked]="(indexOfElement == 0) ? true: false" id="{{requestType.name.toLowerCase() + 'RadioButton'}}">
            </dxp-radio-button>
        </dxp-radio-group>
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout>
    <dxp-flex-layout-item slot="column-1" column-width-lg="12" padding-style-sm="0px 0px 0px 15px" id="total-records">
        Total: {{this.requests.length}} record(s)
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout id="mc-request-list">
    <div  class="request-list-container"
    [ngStyle]="{'height': this.setVariableHeight ? this.getRequestListContainerHeight(): ''}">
        <dxp-flex-layout-item slot="column-1" column-width-lg="12" padding-style-sm="0px 0px">
            <div class="loading-message" *ngIf="this.enableLoadingMessage">Records are loading...</div>
            <div *ngFor="let request of this.requests;" class="request-container border-bottom">
                <div (click)="this.viewRequest(request)" [id]="request.requestId" class="request" [ngClass]="requestIdSelected == request.requestId ? 'border-left' : '' ">
                    <div class="request-status">
                        <span [ngClass]="requestIdSelected == request.requestId ? 'text-color' : '' "><strong>{{request.requestId}}</strong></span>
                        <dxp-pills [text]="request.status.text" removable=false></dxp-pills>
                    </div>
                    <div>{{request.requesterName}}</div>
                    <div><strong>{{request.displayValue.key}}: {{request.displayValue.value}}</strong></div>
                    <div><strong>Requested on (UTC): {{request.requestCreationUTCTime | date: "dd MMM yyyy hh.mm a"}}</strong></div>
                </div>
            </div>
        </dxp-flex-layout-item>
    </div>
</dxp-flex-layout>